// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b335bf3880bc8e2c85c17647fafd72ce21d438f6/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};